import get from 'lodash/get';

import { createSelector } from 'reselect';

export const selectRootState = state =>
  get(state, 'managePatientInsurances.deletePatientInsurance');

export const selectInsuranceIsDeleting = createSelector(
  selectRootState,
  state => get(state, 'sending', false),
);

export const selectIsInsuranceDeleteSucceeded = createSelector(
  selectRootState,
  state => get(state, 'succeed', false),
);



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/selectors/delete-patient-insurance.js